window.updateCardVariant = function updateCardVariant(select) {
  const content = select.closest('.p-content');
  if (!content) return;

  const option = select.options[select.selectedIndex];
  const variantInput = content.querySelector('input[name="id"]');
  const price = content.querySelector('strong');
  const strike = content.querySelector('.p-strike-btn');

  if (variantInput) variantInput.value = select.value;
  if (price) price.innerText = option.dataset.price;

  if (!strike) return;
  if (option.dataset.compare) {
    strike.innerText = option.dataset.compare;
    strike.style.display = 'inline-block';
  } else {
    strike.style.display = 'none';
  }
};
